import { call, put, takeEvery } from 'redux-saga/effects';
import request from '../../utils/request';
import errorMessages from '../../components/Error/messages';
import {
  API_URL_WEBMASTER_PAYMENT_INFO,
  API_URL_WEBMASTER_PAYMENT_INFO_UPDATE,
} from '../../config';
import * as constants from './constants';
import { getAuthToken } from '../../containers/Auth/token';
import {
  savePaymentInfoSuccess,
  savePaymentInfoError,
  getPaymentInfoSuccess,
  getPaymentInfoError,
} from './actions';

function getPaymentInfoRequest(token) {
  const data = JSON.stringify({
    token,
    paysystem: 'bank',
  });
  const url = `${API_URL_WEBMASTER_PAYMENT_INFO}?data=${data}`;
  const options = {
    method: 'GET',
  };

  return request(url, options);
}

function* getPaymentInfoFlow() {
  try {
    const token = yield getAuthToken();
    const result = yield call(getPaymentInfoRequest, token);
    const { response } = result;
    if (response.success === 1) {
      yield put(getPaymentInfoSuccess(response.data));
      return;
    }
    throw errorMessages.defaultMessage;
  } catch (error) {
    yield put(getPaymentInfoError(error));
  }
}

function savePaymentInfoRequest(token, action) {
  const { attributes } = action;
  const options = {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body: `data=${JSON.stringify({
      token,
      paysystem: 'bank',
      account_owner: attributes.accountOwner,
      iban: attributes.iban,
      swift: attributes.swift,
      bank_name: attributes.bankName,
      country: attributes.country,
    })}`,
  };

  return request(API_URL_WEBMASTER_PAYMENT_INFO_UPDATE, options);
}

function* savePaymentInfoFlow(action) {
  try {
    const token = yield getAuthToken();
    const result = yield call(savePaymentInfoRequest, token, action);
    const { response } = result;
    if (response.success === 1) {
      yield put(savePaymentInfoSuccess(response.data));
      return;
    }
    throw errorMessages.defaultMessage;
  } catch (error) {
    yield put(savePaymentInfoError(error));
  }
}

// run in parallel
export default function* rootSaga() {
  yield takeEvery(constants.GET_PAYMENT_INFO_REQUEST, getPaymentInfoFlow);
  yield takeEvery(constants.SAVE_PAYMENT_INFO_REQUEST, savePaymentInfoFlow);
}



// WEBPACK FOOTER //
// ./src/containers/PaymentInfo/sagas.js